import type { NavButtonLinkProps } from "./nav-button-link.type";

import { NavButton } from "@/modules/nav-button";
import { useNavigationLink } from "@/modules/navigation";

export const NavButtonLink = ({
  linkKey,
  title,
  className,
}: NavButtonLinkProps) => {
  const link = useNavigationLink(linkKey);

  if (!link) return null;

  const { url, external, text, icon } = link;

  return (
    <NavButton
      link={{ to: url, external }}
      title={title ?? text}
      icon={icon}
      className={className}
    />
  );
};
